import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { LoginService } from '../../../services/login.service';
import { googleConfig } from '../../../../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { piecesTheme } from '../../../../shared/js/chess';
import { ProfileService } from '../../../../shared/services/profile.service';
import { Subscription, interval } from 'rxjs';
import { socket } from '../../../../shared/helpers/socketio';
import { Themeservice } from '../../../services/theme.service';
import { DecryptionService } from '../../../../shared/services/decryption.service';
@Component({
  selector: 'app-signin',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, RouterModule],
  templateUrl: './signin.component.html',
  styleUrl: './signin.component.scss',
})
export class SigninComponent implements OnDestroy {
  protected loginform!: FormGroup;
  emailControl = new FormControl('', Validators.required);
  resetEmail!: FormGroup;
  confirmOtp!: FormGroup;
  showPassword: boolean = false;
  submitted: boolean = false;
  displayStyle = 'none';
  displayStyle2 = 'none';
  displayStyle3 = 'none';
  otpNumber = false;
  tokenAccess = false;
  otptoken: any;
  shownewpassword: boolean = false;
  forgotpassword!: FormGroup;
  token!: string;
  countdown: number = 60;
  isButtonDisabled: boolean = true;
  timerSubscription: Subscription | undefined;
  confirmPasswordClass = 'form-control';

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private signIn: LoginService,
    private route: ActivatedRoute,
    private http: HttpClient,
    private themeService: Themeservice,
    private toastr: ToastrService,
    private decryptionApi: DecryptionService
  ) {}

  ngOnInit() {
    const code = this.route.snapshot.queryParams['code'];

    if (code) {
      googleConfig.exchangeCodeForIdToken(code, this.http, this.signIn);
    }
    this.loginformdata();
  }

  signInWithGoogle(): void {
    googleConfig.googleClick();
    // this.boardapidata();
  }

  startCountdown(): void {
    this.stopCountdown(); // Ensure any existing timer is stopped before starting a new one
    this.isButtonDisabled = true;
    this.countdown = 60; // Reset countdown
    this.timerSubscription = interval(1000).subscribe(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        this.isButtonDisabled = false;
        this.stopCountdown();
      }
    });
  }
  stopCountdown(): void {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
      this.timerSubscription = undefined;
    }
  }
  resetCountdown(): void {
    this.countdown = 60;
    this.isButtonDisabled = true;
    this.startCountdown();
  }

  onResend(): void {
    this.resetCountdown();
    let email = this.resetEmail.value;
    email['email'] = email['forgetemail'];
    if (email.query === null) {
      return;
    }
    this.signIn.forgetpassword(email).subscribe({
      next: (response: any) => {
        this.toastr.success(response.messages);
        this.startCountdown();
      },
    });
  }

  ngOnDestroy(): void {
    this.timerSubscription?.unsubscribe();
  }

  loginformdata() {
    this.loginform = this.fb.group({
      query: this.emailControl,
      password: ['', Validators.required],
      // recaptcha: ['', Validators.required]
    });

    this.resetEmail = this.fb.group({
      query: ['', Validators.required],
    });

    this.confirmOtp = this.fb.group({
      otp: ['', Validators.required],
    });

    this.forgotpassword = this.fb.group(
      {
        newPassword: new FormControl(null, Validators.required),
        confirmPassword: new FormControl(null, Validators.required),
      },
      {
        validator: this.ConfirmedValidator('newPassword', 'confirmPassword'),
      }
    );
  }

  ConfirmedValidator(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      if (
        matchingControl.errors &&
        !matchingControl.errors['confirmedValidator']
      ) {
        return;
      }
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ confirmedValidator: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  login(data: any) {
    this.signIn.postSignIn(data).subscribe({
      next: (response: any) => {
        const decrypt = this.decryptionApi.decrypt(response.payload);
        const jsondecrpt = JSON.parse(decrypt);
        this.signIn.setFormData(jsondecrpt);
        socket.emit('online', jsondecrpt.username);
        localStorage.setItem(
          'boardPieces',
          JSON.stringify(jsondecrpt.boardAndPieces)
        );
        document.documentElement.style.setProperty(
          '--local-storage-oddcolor',
          jsondecrpt.boardAndPieces?.white
        );
        document.documentElement.style.setProperty(
          '--local-storage-color',
          jsondecrpt.boardAndPieces?.black
        );
        piecesTheme(jsondecrpt.boardAndPieces.pieces);
        this.themeService.setTheme(jsondecrpt.theme);
        document.body.className = jsondecrpt.theme;
      },
      error: (error: any) => {
        this.toastr.error(error);
      },
    });
    this.signIn.setLoginProcessStatus(true);
  }

  savePopup() {
    let email = this.resetEmail.value;
    email['email'] = email['forgetemail'];
    if (email.query === null) {
      return;
    }
    this.signIn.forgetpassword(email).subscribe({
      next: (response: any) => {
        this.startCountdown();
        if (response.success) {
          this.otpNumber = true;
          this.closePopup();
        } else {
          this.otpNumber = false;
        }
        this.toastr.success(response.messages);
      },
      error: (error: any) => {
        this.toastr.error(error.error.message);
      },
    });
  }

  closePopup() {
    this.displayStyle = 'none';
    if (this.otpNumber) {
      this.displayStyle2 = 'block';
    }
  }

  forgetpass() {
    this.displayStyle = 'block';
    this.otpNumber = false;
    this.tokenAccess = false;
    this.resetEmail.reset();
    this.confirmOtp.reset();
  }

  OtpPopups() {
    const email = this.resetEmail.value;
    email['email'] = email['forgetemail'];
    const otp = this.confirmOtp.value;
    let otpData = {
      query: email.query,
      otp: otp.otp,
    };

    this.signIn.verifyOtpCode(otpData).subscribe({
      next: (response) => {
        const decrypt = this.decryptionApi.decrypt(response.payload);
        const jsondecrpt = JSON.parse(decrypt);
        if ((response.success = true)) {
          this.tokenAccess = true;
          this.otpClosePopUp();
        }
        this.otptoken = jsondecrpt;
        this.signIn.setFormData(jsondecrpt);
        this.signIn.setLoginProcessStatus(true);
      },
    });
  }

  otpClosePopUp() {
    this.displayStyle2 = 'none';
    if (this.tokenAccess) {
      this.displayStyle3 = 'block';
    }
    this.confirmOtp.reset();
    this.resetEmail.reset();
  }

  onSubmit(data: any): void {
    const confirmPasswordData = {
      password: data.confirmPassword,
    };
    this.signIn
      .Forgetpassword(this.otptoken.token, confirmPasswordData)
      .subscribe({
        next: (response: any) => {
          this.toastr.success(response.messages);
        },
        error: (error) => {
          this.router.navigate(['home']);
          this.toastr.error(error.error.messages);
        },
      });
    this.resetclosepopup();
  }

  resetclosepopup() {
    this.displayStyle3 = 'none';
    this.displayStyle2 = 'none';
    this.displayStyle = 'none';
    this.forgotpassword.reset();
    this.router.navigate(['login']);
  }
}
